import {
  JACKET_AND_PANTS,
  SHIRT,
  TIE,
  VEST_AND_CUMMERBUND,
  POCKET_SQUARE,
  LAPEL_PIN,
  CUFFLINKS,
  BELT_AND_SUSPENDERS,
  SHOES,
  SOCKS,
} from './categories';

export const listCategories = [
  {
    name: 'Jacket & Pants',
    category: JACKET_AND_PANTS,
    activeItem: '',
    isBundle: true,
    bundleName: 'Mystic Blue Peak Lapel Suit',
    icon: 'jacket',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-jacket.png',
    mktCopy:
      'The best starting point. Choose your color and jacket style, and start designing the perfect suit or  tuxedo for your event.',
  },
  {
    name: 'Shirt',
    category: SHIRT,
    activeItem: '',
    icon: 'shirt',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-shirt.png',
    mktCopy: 'Different patterns, different weights, but all the same high quality look.',
  },
  {
    name: 'Tie',
    category: TIE,
    activeItem: '',
    icon: 'tie',
    placeholder: 'https://gentux.imgix.net/1591704712_200608-151436-tie.png',
    mktCopy:
      'A small touch of color that brings your wedding party together. Choose a bow tie or standard tie to make your suit or tuxedo perfect.',
  },
  {
    name: 'Vest & Cummerbund',
    category: VEST_AND_CUMMERBUND,
    activeItem: '',
    icon: 'vest',
    placeholder: 'https://gentux.imgix.net/1591704712_200608-151436-vest.png',
    mktCopy: 'Complete the look. Include a vest on your suit or tuxedo to create a timeless look that won’t be forgotten.',
  },
  {
    name: 'Pocket Square',
    category: POCKET_SQUARE,
    activeItem: '',
    icon: 'pocket_square',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-pocket_square.png',
    mktCopy:
      'A small touch that makes a big difference. Include a pocket square to finish off the look on your big day.',
  },
  {
    name: 'Lapel Pin',
    category: LAPEL_PIN,
    activeItem: '',
    icon: 'lapel_pin',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-lapel_pin.png',
    mktCopy:
      'A finishing touch that tops off your suit or tuxedo. Our Lapel Pins come in a variety of colors that will go on easy, but won’t go unnoticed.',
  },
  {
    name: 'Cufflinks',
    category: CUFFLINKS,
    activeItem: '',
    icon: 'cufflinks',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-cufflinks.png',
    mktCopy: 'Details matter when all eyes are on you. Cufflinks add a little extra, but go a long way.',
  },
  {
    name: 'Belt & Suspenders',
    category: BELT_AND_SUSPENDERS,
    activeItem: '',
    icon: 'belt',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-belt.png',
    mktCopy:
      'Sometimes the most underestimated part of the look. Matching the right belt to your shoes makes the suit perfect.',
  },
  {
    name: 'Shoes',
    category: SHOES,
    activeItem: '',
    icon: 'shoe',
    placeholder: 'https://gentux.imgix.net/1591704711_200608-151436-shoes.png',
    mktCopy:
      'Shoes can really change the overall look of your suit or tuxedo. You can’t go wrong with one of our three options.',
  },
  {
    name: 'Socks',
    category: SOCKS,
    activeItem: '',
    icon: 'socks',
    placeholder: 'https://gentux.imgix.net/1591704712_200608-151436-socks.png',
    mktCopy: 'Let a little of your personality out with the subtle touch of socks.',
  },
];
